import { defineComponent, onMounted, ref, watch, onUnmounted, getCurrentInstance } from "vue";
import Hamburger from "./hamburger.vue";
import { asyncRouterMap } from "@pt/router";
import Cookies from "js-cookie";
import store from "@pt/store";
export default defineComponent({
    components: {
        Hamburger: Hamburger
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var isCollapse = ref(false);
        var defaultActive = ref("");
        var routerMap = asyncRouterMap;
        var menuList = ref([]);
        watch(function() {
            var _$ref;
            return (_$ref = store.state.user) === null || _$ref === void 0 ? void 0 : _$ref.roles;
        }, function() {
            menuList.value = [];
            routerMap.forEach(function(item) {
                var temp = {
                    title: "",
                    index: "",
                    subMenu: []
                };
                if (!item.hiddenChildren && item.children && item.children.length) {
                    item.children.forEach(function(child) {
                        var isHidden = typeof child.hidden === "function" ? child.hidden() : child.hidden;
                        if (temp.subMenu && !isHidden) {
                            temp.subMenu.push({
                                title: child.meta && child.meta.title ? child.meta.title : "",
                                index: "".concat(item.path, "/").concat(child.path)
                            });
                        }
                    });
                }
                var isHidden1 = typeof item.hidden === "function" ? item.hidden() : item.hidden;
                if (!isHidden1) {
                    temp.title = item.meta && item.meta.title ? item.meta.title : "";
                    temp.index = item.path;
                    temp.icon = item.icon ? item.icon : "";
                    menuList.value.push(temp);
                }
            });
        }, {
            immediate: true
        });
        var toggleSideBar = function() {
            isCollapse.value = !isCollapse.value;
            Cookies.set("sidebarStatus", isCollapse.value ? "1" : "0");
        };
        var watchWinSize = function() {
            if (Cookies.get("sidebarStatus") === "1") {
                return;
            }
            isCollapse.value = !!(window.innerWidth <= 1280);
        };
        onMounted(function() {
            if (Cookies.get("sidebarStatus")) {
                isCollapse.value = Number(Cookies.get("sidebarStatus")) === 1;
            }
            window.addEventListener("resize", watchWinSize);
            watch(function() {
                return root.$route;
            }, function() {
                defaultActive.value = root.$route.meta.defaultPath;
            }, {
                immediate: true
            });
        });
        onUnmounted(function() {
            window.removeEventListener("resize", watchWinSize);
        });
        return {
            defaultActive: defaultActive,
            isCollapse: isCollapse,
            toggleSideBar: toggleSideBar,
            menuList: menuList
        };
    }
});
